<template>
  <div class="news">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>新聞</p>
    </div>
    <el-form>
      <el-form-item label="新聞名稱:" v-if="news.newsBlock !== '7'">
        <input
          maxlength="100"
          class="el-input__inner"
          type="text"
          v-model="news.newsName"
        />
      </el-form-item>

      <el-form-item label="新聞版塊:" v-if="type === 'edit'">
        <el-select
          v-model="news.newsBlock"
          placeholder="請選擇新聞版塊"
          :disabled="newStatus == 1 || newStatus == 3"
          @change="changeSelectValue"
        >
          <el-option label="小版工" value="3"></el-option>
          <el-option label="vlog" value="2"></el-option>
          <el-option label="社群" value="7"></el-option>
          <el-option label="新聞" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-else label="新聞版塊:">
        <el-select
          v-model="news.newsBlock"
          @change="changeSelectValue"
          placeholder="請選擇新聞版塊"
        >
          <el-option label="小版工" value="3"></el-option>
          <el-option label="vlog" value="2"></el-option>
          <el-option label="社群" value="7"></el-option>
          <el-option label="新聞" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Vlog分类" v-if="news.newsBlock === '2'">
        <el-radio-group v-model="news.vlogType">
          <el-radio
            v-for="item in normalClassify"
            :key="item.id"
            :label="item.vlogType.toString()"
            :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
          >
            {{ item.vlogTypeName }}
          </el-radio>

          <el-radio
            v-for="item in otherClassify"
            :key="item.id"
            :label="item.vlogType"
            :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
          >
            其他
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="popMesShow" label="推送:">
        <el-switch active-color="#6C3DEA" v-model="popMesFlag"> </el-switch>
      </el-form-item>
      <el-form-item v-else label="推送:">
        <el-switch
          active-color="#6C3DEA"
          :value="push == 'true' ? true : false"
          :disabled="true"
        >
        </el-switch>
      </el-form-item>

      <el-form-item
        v-if="popMesShow && news.newsBlock == '7' && popMesFlag"
        label="推送標題:"
      >
        <input type="text" class="el-input__inner" v-model="news.pushTitle" />
      </el-form-item>

      <el-form-item label="定時發佈:">
        <el-switch
          :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
          active-color="#6C3DEA"
          v-model="timingFlag"
          @change="changeTimingFlag"
        >
        </el-switch>
      </el-form-item>

      <el-form-item label="新聞類型 ：">
        <el-radio-group v-model="layout">
          <el-radio v-if="news.newsBlock === '2'" :label="0" disabled
            >圖文</el-radio
          >
          <el-radio
            v-else
            :label="0"
            :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
            >圖文</el-radio
          >
          <el-radio
            :label="1"
            :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
            >視頻</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item v-show="timingFlag" label="發佈時間:">
        <el-date-picker
          v-model="news.publishTime"
          type="datetime"
          placeholder="選擇時間"
          format="yyyy-MM-dd HH:mm"
          :disabled="(newStatus == 1 || newStatus == 3) && type === 'edit'"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="上傳主圖:" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :data="uploadData"
          :on-remove="newsHandleRemove"
          :on-error="$errorImage"
          :file-list="newsList"
          :on-exceed="$handleExceed.bind(this, 18)"
          :on-change="handleChange"
          :before-upload="beforePicUpload"
          :on-progress="uploadImgProcess"
          :limit="0"
          accept=".jpg,.jpeg,.png"
          :multiple="false"
          name="multipartFile"
          list-type="picture-card"
        >
          <el-button v-if="!imgUploadFlag" size="small" type="primary"
            >選擇圖片</el-button
          >
          <div slot="tip" class="el-upload__tip">支持jpg/png格式</div>
          <el-progress
            v-if="imgUploadFlag"
            type="circle"
            :percentage="imgUploadPercent"
            style="margin-top: 10px"
          ></el-progress>
        </el-upload>
      </el-form-item>

      <el-form-item label="上傳影片 :" v-if="layout == 1">
        <video
          width="80%"
          v-if="VideoUrl.length == 1"
          class="avatar"
          :src="VideoUrl[0].url"
          controls="controls"
        >
          您的浏览器不支持视频播放
        </video>
        <span
          style="cursor: pointer"
          @click="handleVideoRemove()"
          v-if="VideoUrl.length == 1"
          >刪除</span
        >
        <el-upload
          action=""
          :http-request="uploadRequest"
          :with-credentials="true"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :data="uploadData"
          :on-error="errorVideo"
          :on-exceed="handleVideoExceed"
          :on-remove="handleVideoRemove"
          :on-progress="uploadVideoProcess"
          :file-list="VideoUrl"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
          :limit="1"
          accept=".mp4"
          :multiple="false"
          name="multipartFile"
          list-type="picture-card"
        >
          <el-button v-if="!videoFlag" size="small" type="primary"
            >選擇視頻</el-button
          >
          <div slot="tip" class="el-upload__tip">支持mp4格式</div>
          <el-progress
            v-if="videoFlag"
            type="circle"
            :percentage="videoUploadPercent"
            style="margin-top: 10px"
          ></el-progress>
        </el-upload>
      </el-form-item>

      <el-form-item label="上传excel:" v-if="news.newsBlock === '3'">
        <div class="excel_list" v-for="(obj, index) of excelArr" :key="index">
          <div class="excel_input">
            <input
              type="file"
              @change="uploadExcel($event, index)"
              accept=".xls, .xlsx"
            />
            <span>{{ obj.fileName }}</span>
          </div>
          <template v-if="index === 0">
            <div
              class="add_btn"
              @click="delExcelArr(index)"
              v-if="!!obj.fileName"
            >
              删除
            </div>
            <div class="add_btn" @click="addExcelArr">添加</div>
          </template>
          <div class="add_btn" @click="delExcelArr(index)" v-else>删除</div>
        </div>
      </el-form-item>

      <div class="editor-wrap">
        <p class="editor-title normal_font">圖文詳情:</p>
        <Editor
          class="editor"
          style="color: #fff"
          @listenContent="getContent"
          :colorFlag="true"
          :content="content"
          :newsFlag="true"
        ></Editor>
      </div>
    </el-form>

    <div class="bottomBtn">
      <div class="btn" @click="submitContent('push')">發佈</div>
      <div style="margin-left: 30px" v-if="pageType != 'edit'">
        <div
          class="btn"
          v-if="news.newsName || newsList.length > 0 || content"
          @click="submitContent('draft')"
        >
          保存爲草稿箱
        </div>
        <div class="btn" v-else style="background-color: #9999a1">
          保存爲草稿箱
        </div>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import DiaMess from "@/components/dialog";

export default {
  props: ["type", "id", "block", "status", "push", "pageType"],
  data() {
    return {
      news: {
        newsName: "",
        newsBlock: "",
        // newsType: '',
        publishTime: "",
        vlogType: "",
        pushTitle: "",
      },
      newsList: [],
      VideoUrl: [],
      vlogClassify: [],
      videoUploadPercent: "",
      videoFlag: false,
      content: "", // 图文详情
      uploadData: {
        // 上传图片的附加参数
        flag: "xw",
      },
      layout: 0,
      popMesFlag: false, //小版工是否推送消息
      timingFlag: false, // 定时发布flag
      userLayout: 0,
      originalPublishTime: "", // 原始发布时间
      originalTimeFlag: null, // 原始是否定时发布
      imgUploadFlag: false, // 主图上传进度条显示flag
      imgUploadPercent: "", // 主图上传进度条
      dialogVisible: false,
      excelArr: [{}],
      newStatus: "",
      // pushStatus:false,
    };
  },
  created() {
    let _this = this;
    _this.getVlogClassify();
    if (_this.type === "edit" || _this.type === "draft") {
      _this.getNewsDetails();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取vlog分类
    getVlogClassify() {
      this.$post(`/request/article/getVlogTypes`, this.$GLOBAL.jsonConfig).then(
        (res) => {
          if (res.code === "00000") {
            this.vlogClassify = res.data;
          }
        }
      );
    },
    // 编辑获取新闻详情
    getNewsDetails() {
      let _this = this;
      _this
        .$get(
          `/request/article/getArticleDetail/${_this.id}`,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            _this.newStatus = res.data.status;
            let timeFormat;
            timeFormat = _this.$compareTime(res.data.publishDate, new Date());
            // 后台传来的publishDate为空，或者publishDate是过去时间，那么为即时发布
            if (_this.type == "edit") {
              if (
                res.data.publishDate === null ||
                res.data.publishDate === "" ||
                timeFormat === false
              ) {
                _this.timingFlag = false;
                _this.originalTimeFlag = false;
              } else {
                // 否则为定时发布
                _this.timingFlag = true;
                _this.originalTimeFlag = true;
              }
            } else {
              if (res.data.status == 2) {
                _this.timingFlag = true;
                _this.originalTimeFlag = true;
              } else {
                _this.timingFlag = false;
                _this.originalTimeFlag = false;
              }
            }
            _this.popMesFlag = res.data.jpushFlag == 1 ? true : false;
            _this.originalPublishTime = res.data.publishDate; //保存原始发布时间
            _this.userLayout = res.data.oriType;
            _this.news.publishTime = res.data.publishDate;
            _this.news.newsName = res.data.title;
            _this.news.newsBlock = _this.block == 0 ? "" : _this.block;
            _this.news.vlogType = res.data.diaryType;
            if (res.data.vlogUrl) {
              _this.VideoUrl.push({ name: "video.mp4", url: res.data.vlogUrl });
            }
            _this.content = res.data.context;
            // _this.pushStatus=res.data.push == 1 ? true : false;
            if (
              _this.news.newsBlock === "7" &&
              res.data.autodyneUrls.length > 0
            ) {
              this.newsList = res.data.autodyneUrls.map((val, index) => ({
                name: index + "img.jpg",
                url: val,
              }));
            } else {
              if (res.data.primaryPictureUrl) {
                _this.newsList.push({
                  name: "img.jpg",
                  url: res.data.primaryPictureUrl,
                });
              }
            }
            if (res.data.vlogUrl == null) {
              _this.layout = 0;
            } else {
              _this.layout = 1;
            }
            if (_this.news.newsBlock === "7") {
              if (_this.newsList.length >= 18) {
                document.getElementsByClassName("el-upload")[0].style.display =
                  "none";
              }
            } else {
              if (_this.newsList.length > 0 && _this.news.newsBlock !== "7") {
                document.getElementsByClassName("el-upload")[0].style.display =
                  "none";
              }
            }
            let fileList = res.data.fileList;
            if (!fileList.length) {
              fileList = [{}];
            }
            this.excelArr = fileList;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 上传图片之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "上傳圖片只能是jpg或者png格式",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );

        return false;
      }

      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過20MB", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000,
              })
              .then((res) => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },

    // 移除图片的回调函数
    newsHandleRemove(file, fileList) {
      let _this = this;
      _this.imgUploadFlag = false;
      _this.$deleteUidItem(file.uid, _this.newsList);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
    // uploadRequest(option){

    //   const file = option.file
    //   const self = this
    //   return new Promise((resolve, reject) => {
    //     const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
    //     const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
    //     let randomStr = self.$randomString(4)//  4位随机字符串
    //     const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
    //     const fileWay = 'resource/image/'
    //     const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
    //     // 执行上传
    //     self.$createOssClient().then(client => {
    //       // console.log(client)
    //       // 异步上传,返回数据
    //       // resolve({
    //       //   fileName: file.name,
    //       //   fileUrl: fileName, // 图片路径
    //       // })
    //       // 上传处理
    //       // 分片上传文件
    //       client.multipartUpload(fileName, file,{
    //         progress: function(p) {
    //           console.log(p)
    //           if(p>0){
    //             self.imgUploadFlag = true
    //           } else if(p=1){
    //             self.imgUploadFlag = false
    //           }
    //           self.imgUploadPercent =  Math.floor(p * 100)
    //         },headers:{'Cache-Control':'public'}})
    //       .then((val) => {
    //         if (val.res.statusCode === 200) {
    //           self.newsList.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl+ val.name + self.$GLOBAL.xwPic})
    //           document.getElementsByClassName('el-upload')[0].style.display = 'none';
    //           //cdn预热
    //           self.$cdnFun(self.newsList[0].url).then(res=>{
    //             // console.log(res)
    //           })
    //           return val
    //         } else {
    //           self.newsList = [];
    //           option.onError('上传失败')
    //         }
    //       }, err => {
    //         self.newsList = [];
    //         option.onError('上传失败')
    //         reject(err)
    //       })
    //     })
    //   })
    // },
    // 上传视频
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        let fileWay = "";
        if (
          extensionName === ".mp4" ||
          extensionName === ".MP4" ||
          extensionName === ".Mp4" ||
          extensionName === ".mP4"
        ) {
          fileWay = "resource/video/";
        } else {
          fileWay = "resource/image/";
        }
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        console.log(fileName);
        // 执行上传
        self.$createOssClient().then((client) => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              progress: function (p) {
                if (
                  extensionName === ".mp4" ||
                  extensionName === ".MP4" ||
                  extensionName === ".Mp4" ||
                  extensionName === ".mP4"
                ) {
                  if (p > 0) {
                    self.videoFlag = true;
                  }
                  self.videoUploadPercent = Math.floor(p * 100);
                } else {
                  if (p > 0) {
                    self.imgUploadFlag = true;
                  }
                  self.imgUploadPercent = Math.floor(p * 100);
                }
              },
              headers: { "Cache-Control": "public" },
            })
            .then(
              (val) => {
                if (val.res.statusCode === 200) {
                  if (
                    extensionName === ".mp4" ||
                    extensionName === ".MP4" ||
                    extensionName === ".Mp4" ||
                    extensionName === ".mP4"
                  ) {
                    self.VideoUrl.push({
                      name: "video.mp4",
                      url: self.$GLOBAL.picFileUrl + val.name,
                    });

                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                    //cdn预热
                    // self.$cdnFun(self.VideoUrl[0].url).then(res=>{
                    //   this.pushTaskId=res.data.pushTaskId
                    // })
                    self.$convertVideo(val.name).then((res) => {
                      console.log(res);
                    });
                  } else {
                    self.newsList.push({
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic,
                    }); // 展示图片
                    console.log("图片路径" + self.newsList[0].url);

                    //cdn预热
                    self.$cdnFun(self.newsList[0].url).then((res) => {
                      console.log(res);
                    });
                    console.log(document.getElementsByClassName("el-upload"));
                    if (self.news.newsBlock === "7") {
                      if (self.newsList.length >= 18) {
                        document.getElementsByClassName(
                          "el-upload"
                        )[0].style.display = "none";
                      }
                    } else {
                      document.getElementsByClassName(
                        "el-upload"
                      )[0].style.display = "none";
                    }
                    self.imgUploadFlag = false;
                  }
                  return val;
                } else {
                  option.onError("上传失败1");
                }
              },
              (err) => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    uploadExcel(event, index) {
      let input = event.target;
      let file = input.files[0];
      let fileName = file.name;
      if (!this.checkFile(fileName)) {
        this.dialogVisible = true;
        this.$propMessage("请上传正确的文件", "error", () => {
          this.dialogVisible = false;
        });
      }
      this.$createOssClient().then((client) => {
        client
          .multipartUpload(fileName, file, {
            headers: { "Cache-Control": "public" },
          })
          .then((res) => {
            console.log(res);
            input.value = "";
            if (res.res.statusCode === 200) {
              let obj = {
                fileName: res.name,
                fileUrl: this.$GLOBAL.picFileUrl + res.name,
              };
              this.excelArr.splice(index, 1, obj);
            } else {
              this.dialogVisible = true;
              this.$propMessage("上传失败", "error", () => {
                this.dialogVisible = false;
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    addExcelArr() {
      this.excelArr.push({});
    },
    delExcelArr(index) {
      if (index === 0) {
        let arr = this.excelArr.concat();
        arr[0] = {};
        this.excelArr = arr.concat();
        return false;
      }
      this.excelArr.splice(index, 1);
    },
    checkFile(fileName) {
      let arr = fileName.split(".");
      let length = arr.length - 1;
      return ["xlsx", "xls"].includes(arr[length]);
    },
    changeTime(val) {
      let time = new Date(val).getTime();
      let now = new Date().getTime();
      if (time < now) {
        this.dialogVisible = true;
        this.$propMessage("請選擇大於當前時間", "error", () => {
          this.dialogVisible = false;
          this.news.publishTime = "";
        });
      }
    },
    // 图片上传进度条
    uploadImgProcess(event, file, fileList) {
      console.log(event);
      this.imgUploadFlag = true;
      this.imgUploadPercent = file.percentage.toFixed(0);
    },
    // 图片列表发生改变的回调函数
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    //上傳視頻回調
    beforeVideoUpload(file) {
      let _this = this;
      // const isVideo = file.type === 'video/mp4' || 'video/3gp' || 'video/3gpp' || 'video/rm' || 'video/rmvb' || 'video/avi' || 'video/wmv' || 'video/mov';
      const isVideo = file.type === "video/mp4";
      // const isLt2GB = file.size / 1024 / 1024 < 10240;
      if (!isVideo) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳視頻格式不正確", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      // if (!isLt2GB) {
      //   _this.$Mint.Toast('上傳視頻大小不能超過10GB!');
      //   return false;
      // };
    },
    handleVideoRemove(file) {
      let _this = this;
      _this.VideoUrl = [];
      _this.videoFlag = false;
      _this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
      return false;
    },
    changeTimingFlag() {
      this.news.publishTime = "";
    },
    // 视频上传进度条
    uploadVideoProcess(event, file, fileList) {
      console.log(event);
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0);
    },
    errorVideo() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("上傳失敗！", "error", function () {
        _this.dialogVisible = false;
      });
    },
    handleVideoExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一個視頻", "error", function () {
        _this.dialogVisible = false;
      });
      return false;
    },
    // 实时更新富文本内容
    getContent(data) {
      this.content = data;
    },
    // 新闻板块选择改变回调函数
    changeSelectValue(val) {
      let _this = this;
      if (_this.news.newsBlock === "2") {
        _this.layout = 1;
      } else {
        _this.layout = 0;
      }
      if (_this.news.newsBlock === "7") {
        _this.news.newsName = "";
      } else {
        if (!_this.news.newsName) {
          _this.news.newsName = "";
        }
      }

      setTimeout(() => {
        if (_this.news.newsBlock === "7") {
          if (_this.newsList.length >= 18) {
            document.getElementsByClassName("el-upload")[0].style.display =
              "none";
          } else {
            document.getElementsByClassName("el-upload")[0].style.display =
              "inline-block";
          }
        } else {
          if (_this.newsList.length >= 1) {
            document.getElementsByClassName("el-upload")[0].style.display =
              "none";
            _this.newsList = [].concat([_this.newsList[0]]);
          } else {
            document.getElementsByClassName("el-upload")[0].style.display =
              "inline-block";
          }
        }
      }, 100);
      // if(_this.news.newsBlock==='3' || _this.news.newsBlock==='2'){
      //   _this.news.newsType = '會員';
      //   _this.userLayout=1
      // } else {
      //   _this.news.newsType = '全部'
      //   _this.userLayout=0
      // }
    },

    getShortContent(content) {
      let div = document.createElement("div");
      div.innerHTML = content;
      return div.innerText;
    },
    // 提交内容
    submitContent(sort) {
      let _this = this;
      if (this.news.newsBlock !== "7" && sort != "draft") {
        if (
          _this.news.newsName === "" ||
          _this.news.newsName.match(/^\s+$/) ||
          _this.$getCaption(_this.news.newsName)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "新聞名稱不能為空或者含有非法字符",
            "error",
            function () {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
      }
      if (sort == "push") {
        if (_this.type === "add" || _this.type === "draft") {
          if (_this.news.newsBlock === "") {
            _this.dialogVisible = true;
            _this.$propMessage("新聞版塊不能為空", "error", function () {
              _this.dialogVisible = false;
            });
            return false;
          } else if (_this.news.newsBlock === "2") {
            if (_this.news.vlogType === "") {
              _this.dialogVisible = true;
              _this.$propMessage("vlog分类不能為空", "error", function () {
                _this.dialogVisible = false;
              });
              return false;
            }
          } else if (_this.news.newsBlock === "7") {
            //推送标题
            if (this.popMesFlag) {
              if (_this.news.pushTitle === "") {
                _this.dialogVisible = true;
                _this.$propMessage("請輸入推送標題", "error", function () {
                  _this.dialogVisible = false;
                });
                return false;
              }
            }
          }
        }
        if (_this.newsList.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("主圖不能為空", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.VideoUrl.length === 0 && _this.layout == 1) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇上傳影片", "error", function () {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (this.timingFlag && !this.news.publishTime) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇發佈時間", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.timingFlag && this.news.publishTime) {
        let time = new Date(this.news.publishTime).getTime();
        let now = new Date().getTime();
        if (time < now) {
          this.dialogVisible = true;
          this.$propMessage("發佈時間請選擇大於當前時間", "error", () => {
            this.dialogVisible = false;
          });
          return;
        }
      }

      // if (_this.content === '' || _this.content === null) {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('圖文詳情不能為空','error',function(){
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // };

      let fileList = this.getFileList(this.excelArr);
      // 新增新闻提交
      if (_this.type === "add") {
        let time, status;
        let timeFormat = _this.$compareTime(_this.news.publishTime, new Date());
        if (timeFormat === false && _this.timingFlag) {
          //发布时间是过去的时间并且设置定时发布
          status = 1; //传参为即时发布
          time = _this.$formatDate(_this.news.publishTime);
        } else {
          // 即时发布 || 定时发布，发布时间为未来时间
          time = _this.timingFlag
            ? typeof _this.news.publishTime === "string"
              ? _this.news.publishTime
              : _this.$formatDate(_this.news.publishTime)
            : _this.$formatDate(new Date());
          status = _this.timingFlag ? 2 : 1;
        }
        let param = {
          type: _this.news.newsBlock ? Number(_this.news.newsBlock) : null,
          primaryPictureUrl:
            _this.newsList.length > 0 ? _this.newsList[0].url : null,
          context: _this.content,
          publishDate: time,
          status: status,
          jpushFlag: _this.popMesFlag ? 1 : 0,
          vlogUrl:
            _this.layout == 1 && _this.VideoUrl.length > 0
              ? _this.VideoUrl[0].url
              : null,
        };
        if (this.news.newsBlock === "7") {
          param.autodyneUrls = this.newsList.map((val) => val.url);
          param.shortContext = this.getShortContent(this.content);
          //新增推送标题字段
          param.pushTitle = this.news.pushTitle;
        } else {
          param.title = _this.news.newsName;
        }
        if (_this.news.newsBlock === "2") {
          param.diaryType = _this.news.vlogType;
        }

        if (!!fileList.length) {
          param.fileList = fileList;
        }
        let url = "";
        if (sort == "push") {
          url = "/request/article/addArticle";
        } else {
          url = "/request/article/drafts/article";
        }
        _this.$post(url, param, _this.$GLOBAL.jsonConfig).then((res) => {
          _this.dialogVisible = true;

          if (res.code === "00000") {
            _this.$propMessage(
              sort == "push" ? "新增新聞發佈成功" : "新增草稿成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
          } else if (res.code === "40002") {
            if (res.data === "包含非法字符") {
              _this.$propMessage(
                "輸入內容不能包含非法字符，請重試",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
      } else if (_this.type === "edit" || _this.type === "draft") {
        let time, status, publishTime;

        let timeFormat = _this.$compareTime(_this.news.publishTime, new Date());

        if (timeFormat === false && _this.timingFlag) {
          //发布时间是过去的时间并且设置定时发布
          status = 1;
          // 时间为后台传回的时间
          time =
            typeof _this.news.publishTime === "string"
              ? _this.news.publishTime
              : _this.$formatDate(_this.news.publishTime);
        } else {
          // 即时发布 || 定时发布，发布时间为未来时间
          publishTime =
            typeof _this.news.publishTime === "string"
              ? _this.news.publishTime
              : _this.$formatDate(_this.news.publishTime);
          // 如果一开始是定时发布，点击发布时是即时发布
          if (_this.originalTimeFlag == true && _this.timingFlag == false) {
            time = _this.$formatDate(new Date());
          } else {
            // 定时发布的为publishTime,即时发布为现在时间
            time = _this.timingFlag
              ? publishTime
              : _this.$formatDate(new Date());
          }
          // 定时发布为2，即时发布为1

          status = _this.timingFlag ? 2 : 1;
        }
        //改变了时间传publishDate，没有改变时间传updateDate
        let param = {
          id: _this.id,
          type: this.news.newsBlock ? Number(_this.news.newsBlock) : null,
          primaryPictureUrl:
            _this.newsList.length > 0 ? _this.newsList[0].url : null,
          context: _this.content,
          status: status,
          jpushFlag: _this.popMesFlag ? 1 : 0,
          vlogUrl:
            _this.layout == 1 && _this.VideoUrl.length > 0
              ? _this.VideoUrl[0].url
              : null,
          diaryType: _this.news.vlogType,
        };
        if (this.news.newsBlock === "7") {
          param.autodyneUrls = this.newsList.map((val) => val.url);
          param.shortContext = this.getShortContent(this.content);
          //新增推送标题字段
          param.pushTitle = this.news.pushTitle;
        } else {
          param.title = _this.news.newsName;
        }
        if (_this.originalPublishTime == publishTime) {
          if (_this.originalTimeFlag == true && _this.timingFlag == false) {
            param.publishDate = time;
          } else {
            param.updateDate = publishTime;
          }
        } else {
          param.publishDate = time;
        }

        if (!!fileList.length) {
          param.fileList = fileList;
        }
        let urls = "";
        if (sort == "push") {
          urls = "/request/article/editArticle";
        } else {
          urls = "/request/article/drafts/article";
        }
        // 编辑新闻提交
        _this.$post(urls, param, _this.$GLOBAL.jsonConfig).then((res) => {
          _this.dialogVisible = true;

          if (res.code === "00000") {
            _this.$propMessage(
              sort == "push" ? "編輯新聞發佈成功" : "編輯草稿成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
          } else if (res.code === "40002") {
            if (res.data === "包含非法字符") {
              _this.$propMessage(
                "輸入內容不能包含非法字符，請重試",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
      }
    },
    //保存草稿箱
    submitDraft() {
      let _this = this;
      if (this.news.newsBlock !== "7") {
        if (
          _this.news.newsName === "" ||
          _this.news.newsName.match(/^\s+$/) ||
          _this.$getCaption(_this.news.newsName)
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "新聞名稱不能為空或者含有非法字符",
            "error",
            function () {
              _this.dialogVisible = false;
            }
          );
          return false;
        }
      }
      let fileList = this.getFileList(this.excelArr);
      if (_this.id) {
      }
      _this
        .$post(
          "/request/article/drafts/article",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          _this.dialogVisible = true;

          if (res.code === "00000") {
            _this.$propMessage("新增新聞發佈成功", "success", function () {
              _this.dialogVisible = false;
              _this.$router.push("/newsList");
            });
          } else if (res.code === "40002") {
            if (res.data === "包含非法字符") {
              _this.$propMessage(
                "輸入內容不能包含非法字符，請重試",
                "error",
                function () {
                  _this.dialogVisible = false;
                }
              );
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    getFileList(arr) {
      return arr.filter((obj) => JSON.stringify(obj) !== "{}");
    },
  },
  components: {
    Editor,
    DiaMess,
  },
  computed: {
    normalClassify() {
      return this.vlogClassify.filter((item) => item.vlogType !== null);
    },
    otherClassify() {
      return this.vlogClassify.filter((item) => item.vlogType === null);
    },
    popMesShow() {
      if (this.type == "edit") {
        return this.status == 0;
      } else {
        return true;
      }
    },
    timeAfter() {
      let start = new Date().getTime();
      return {
        disabledDate: (time) => time.getTime() <= start - 24 * 60 * 60 * 1000,
      };
    },
  },
};
</script>
<style scoped lang="less">
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  background: #9e9e9e;
}
.news .excel_list {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .excel_input {
    position: relative;
    width: 174px;
    height: 36px;
    border: 1px solid #ababab;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      cursor: pointer;
    }
  }

  .add_btn {
    margin-left: 10px;
    width: 80px;
    height: 36px;
    border: 1px solid #ababab;
    box-sizing: border-box;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    cursor: pointer;
  }

  input[type="file"]::-webkit-file-upload-button {
    cursor: pointer;
  }
}
</style>
<style scoped>
.el-form-item__content {
  white-space: normal;
}
.el-upload-list--picture-card {
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue